<template>
  <modal
    name="editBulkUsersModal"
    :width="modalWidth"
    :minHeight="200"
    :minWidth="200"
    :maxWidth="1300"
    :scrollable="true"
    :adaptive="true"
    :reset="true"
    height="auto"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="modal--container">
      <div class="d-flex justify-content-end pt-3">
        <button type="button" @click="closeModal" class="close">
          <span aria-hidden="true">
            <font-awesome-icon icon="times" size="1x" />
          </span>
        </button>
      </div>

      <form class="mt-3" v-on:submit.prevent="saveEmp">
        <div class="row mt-4">
          <div class="col-12 form-group multi-container">
            <span class="cus-label">Select Employee</span>
            <multiselect
              :multiple="true"
              :value="selected"
              @input="updateSelected"
              :label="selectAll ? 'user_name' : 'name'"
              :track-by="selectAll ? 'user_name' : 'name'"
              placeholder="Select Employee"
              :options="officeEmployees"
            ></multiselect>
          </div>
        </div>

        <div class="row flex-column flex-md-row my-2 mt-2">
          <div
            :class="{
              'col-12 form-group low-opacity': true,
              'full-opacity': officeTeams && officeTeams.length > 0
            }"
          >
            <label>Team *</label>
            <multiselect
              v-model="employeeDetails.team"
              :multiple="true"
              label="name"
              track-by="id"
              placeholder="Select a team"
              :options="officeTeamsOptions"
              :required="officeTeams.length > 0"
            ></multiselect>
          </div>
        </div>

        <div class="row flex-column flex-md-row my-2">
          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Reminder 1</label>
            <select v-model="employeeDetails.first_reminder">
              <option :value="null" selected hidden>Select Reminder</option>
              <option value="no reminder">No reminder</option>
              <option
                v-for="(timeSlot, index) in reminderOptions"
                :value="timeSlot"
                :key="index"
                v-show="isReminderChosen(timeSlot)"
              >
                {{ timeSlot + " minutes" }}
              </option>
            </select>
          </div>
          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Reminder 2</label>
            <select v-model="employeeDetails.second_reminder">
              <option :value="null" selected hidden>Select Reminder</option>
              <option value="no reminder">No reminder</option>
              <option
                v-for="(timeSlot, index) in reminderOptions"
                :value="timeSlot"
                :key="index"
                v-show="isReminderChosen(timeSlot)"
              >
                {{ timeSlot + " minutes" }}
              </option>
            </select>
          </div>
          <div class="col-12 col-md-4 form-group edit-modal-item">
            <label>Reminder 3</label>
            <select v-model="employeeDetails.third_reminder">
              <option :value="null" selected hidden>Select Reminder</option>
              <option value="no reminder">No reminder</option>
              <option
                v-for="(timeSlot, index) in reminderOptions"
                :value="timeSlot"
                :key="index"
                v-show="isReminderChosen(timeSlot)"
              >
                {{ timeSlot + " minutes" }}
              </option>
            </select>
          </div>
        </div>

        <div class="row mt-2 flex-column flex-md-row align-items-center">
          <div
            class="d-flex flex-column col-12 col-md-4 form-group edit-modal-item"
          >
            <label>Subsidy Type *</label>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center mr-4">
                <input
                  class="mr-2"
                  type="radio"
                  id="daily"
                  value="daily"
                  v-model="employeeDetails.subsidy_type"
                />
                <label for="daily">Daily</label>
              </div>

              <div class="d-flex align-items-center">
                <input
                  class="mr-2"
                  type="radio"
                  id="weekly"
                  value="weekly"
                  v-model="employeeDetails.subsidy_type"
                />
                <label for="weekly">Weekly</label>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div
            v-if="employeeDetails.subsidy_type == 'daily'"
            class="col-12 form-group edit-modal-item"
          >
            <label style="font-weight: 500">Daily Subsidy</label>
            <div
              class="d-flex flex-column flex-wrap flex-md-row dailyLimits_container mb-1"
            >
              <div class=" col-md-4 dailyLimit_item">
                <label>Monday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.monday"
                />
              </div>
              <div class=" col-md-4 dailyLimit_item">
                <label>Tuesday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.tuesday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item form-group">
                <label>Wednesday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.wednesday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item form-group">
                <label>Thursday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.thursday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item form-group">
                <label>Friday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.friday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item form-group">
                <label>Saturday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.saturday"
                />
              </div>
              <div class="col-md-4 dailyLimit_item form-group">
                <label>Sunday</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.daily_subsidy.sunday"
                />
              </div>
            </div>
          </div>

          <div v-else class="col-12 form-group edit-modal-item">
            <label style="font-weight: 500">Weekly Subsidy for Dinner</label>
            <div class="row dailyLimits_container mb-1">
              <div class="col-4 dailyLimit_item form-group">
                <label>Subsidy</label>
                <input
                  v-clear
                  @keydown="filterKey($event)"
                  type="text"
                  v-model="employeeDetails.subsidy"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-1 mb-3">
          <div v-if="error" class="col-12 alert alert-danger alert-dismissible">
            <p>{{ this.error }}</p>
          </div>

          <div class="d-flex flex-column flex-md-row w-100 justify-content-end">
            <div class="col my-1 my-md-0">
              <button type="submit" class="save_btn hover-dark">
                Update
              </button>
            </div>

            <div class="col my-1 my-md-0">
              <button
                type="button"
                class="other_btn hover-gray"
                @click="closeModal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>
<script>
import { saveBulkEmployees, getOfficeEmployees } from "../../utils/api";
import { mapState, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import {
  parseDailySubsidyWithFilter,
  parseWeeklySubsidy
} from "../../utils/common";

const CHUNK_SIZE = 20;

export default {
  name: "EditBulkUsersModal",
  data() {
    return {
      employeeDetails: {
        employee_id: "",
        team: [],
        designation: "",
        subsidy_type: "daily",
        subsidy: 0,
        daily_subsidy: [
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
          "sunday"
        ].reduce((acc, day) => ((acc[day] = null), acc), {}),
        first_reminder: null,
        second_reminder: null,
        third_reminder: null
      },
      modalWidth: "95%",
      officeTeams: [],
      teamFilter: "All",
      selectAll: false,
      allItems: 0,
      currentDailySubsidy: {},
      remainingDailySubsidy: {},
      dailyLunchSubsidy: [],
      dailyDinnerSubsidy: [],
      meal: "lunch",
      subsidy: "daily",
      error: "",
      sendEmail: true,
      reminderOptions: ["15", "30", "45", "60", "90", "120", "180"],
      disableFields: false,
      selected: null,
      allEmployees: [],
      allEmployeesList: []
    };
  },
  beforeDestroy() {
    document.body.classList.remove("noscroll");
  },
  mounted() {
    this.modalWidth = window.innerWidth >= 768 ? "70%" : "95%";
  },
  methods: {
    chunkArray(array, size) {
      if (array.length <= size) return [array];
      else {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
          result.push(array.slice(i, i + size));
        }
        return result;
      }
    },
    updateSelected(values) {
      if (this.selectAll) this.selected = values;
      else {
        let updatedList = this.officeEmployees.map(employee => {
          const found = values.find(emp => emp.id === employee.id);

          return {
            ...employee,
            checked: found ? true : false
          };
        });

        this.selected = updatedList.filter(emp => emp.checked);
      }
    },
    filterKey(e) {
      let key = e.keyCode || e.charCode;
      if (
        key !== 9 &&
        key !== 8 &&
        key !== 46 &&
        key !== 190 &&
        key !== 40 &&
        key !== 37 &&
        key !== 39 &&
        key !== 38
      ) {
        if (!e?.key?.trim() || isNaN(e.key)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }
    },
    beforeOpen(event) {
      this.employeeDetails = {
        employee_id: "",
        email: "",
        first_name: "",
        last_name: "",
        team: "",
        designation: "",
        subsidy_type: "daily",
        subsidy: 0,
        daily_subsidy: {
          monday: null,
          tuesday: null,
          wednesday: null,
          thursday: null,
          friday: null,
          saturday: null,
          sunday: null
        },
        first_reminder: null,
        second_reminder: null,
        third_reminder: null
      };
      this.error = "";
      this.disableFields = false;
      this.officeTeams = JSON.parse(
        JSON?.stringify(event?.params?.officeTeams)
      );
      this.teamFilter = JSON.parse(JSON?.stringify(event?.params?.teamFilter));
      this.selectAll = JSON.parse(JSON?.stringify(event?.params?.selectAll));
      this.allEmployeesList = JSON.parse(
        JSON?.stringify(event?.params?.allEmployeesList)
      );
      if (this.officeTeams.length == 1)
        this.employeeDetails.team = this.officeTeams[0].id;

      let loader = this.$loading.show();

      getOfficeEmployees({
        employee_id: this.getFirstEmployeeId,
        team_id: this.teamFilter == "All" ? "" : this.teamFilter,
        all_employees_id_and_name: true,
        include_soft_deleted: false
      })
        .then(response => {
          loader.hide();

          this.selected = this.selectAll
            ? response?.data
            : this.officeEmployees?.filter(emp => emp.checked);

          this.allEmployees = response?.data;
        })
        .catch(() => {
          loader.hide();
        });
    },
    beforeClose() {
      document.body.classList.remove("noscroll");
    },
    closeModal() {
      Object.assign(this.$data, this.$options.data());

      this.$modal.hide("editBulkUsersModal");
    },
    saveEmp() {
      const empDetails = this.employeeDetails;

      const empIds = this?.selected?.map(emp => emp.id).join(" ");

      const chunks = this.chunkArray(empIds, CHUNK_SIZE);

      const payload = {
        location_employee: {},
        user: {},
        emp_ids: empIds
      };

      if (empDetails.first_reminder !== null)
        payload.user.first_reminder = empDetails.first_reminder;

      if (empDetails.second_reminder !== null)
        payload.user.second_reminder = empDetails.second_reminder;

      if (empDetails.third_reminder !== null)
        payload.user.third_reminder = empDetails.third_reminder;

      if (empDetails.team)
        payload.location_employee.team_ids = empDetails.team?.map(
          team => team.id
        );

      if (empDetails.subsidy_type)
        payload.location_employee.subsidy_type = empDetails.subsidy_type;

      if (empDetails.subsidy)
        payload.location_employee.subsidy = parseWeeklySubsidy(
          empDetails.subsidy
        );

      if (
        empDetails.daily_subsidy.monday ||
        empDetails.daily_subsidy.tuesday ||
        empDetails.daily_subsidy.wednesday ||
        empDetails.daily_subsidy.thursday ||
        empDetails.daily_subsidy.friday ||
        empDetails.daily_subsidy.saturday ||
        empDetails.daily_subsidy.sunday
      )
        payload.location_employee.daily_subsidy = parseDailySubsidyWithFilter(
          empDetails.daily_subsidy
        );

      let loader = this.$loading.show();

      saveBulkEmployees(
        {
          employee_id: this.getFirstEmployeeId
        },
        payload,
        chunks
      )
        .then(res => {
          loader.hide();
          this.$root.$emit("setSelectAll", false);

          this.closeModal();
          this.$root.$emit("onGetEmployees");
        })
        .catch(err => {
          loader.hide();
        });
    },
    isReminderChosen(timeSlot) {
      const currentSelectedReminders = [
        +this.employeeDetails.reminder_1_value,
        +this.employeeDetails.reminder_2_value,
        +this.employeeDetails.reminder_3_value
      ];
      return !currentSelectedReminders.includes(timeSlot);
    }
  },
  components: { Multiselect },
  computed: {
    ...mapGetters(["getFirstEmployeeId"]),
    ...mapState(["currentOrganization", "listOfOfficeEmployeesAll"]),
    officeEmployees() {
      if (this.selectAll) {
        return this.allEmployees;
      }

      return this.allEmployeesList
        .map(emp => {
          return {
            ...emp,
            name:
              emp?.name ??
              `${emp?.attributes?.first_name} ${emp?.attributes?.last_name}`
          };
        })
        .concat(this.allEmployees.map(emp => ({ ...emp, name: emp.user_name })))
        .filter((employee, index, self) => {
          return (
            index ===
            self.findIndex(emp => parseInt(emp.id) === parseInt(employee.id))
          );
        });
    },
    updatedReminderOptions() {
      const currentSelectedReminders = [
        +this.employeeDetails.reminder_1_value,
        +this.employeeDetails.reminder_2_value,
        +this.employeeDetails.reminder_3_value
      ];
      const availableReminderOptions = [...this.reminderOptions].filter(
        option => {
          if (+option === +currentSelectedReminders[0]) {
            return false;
          }

          if (+option === +currentSelectedReminders[1]) {
            return false;
          }

          if (+option === +currentSelectedReminders[2]) {
            return false;
          }
          return true;
        }
      );

      return [...availableReminderOptions];
    },
    officeTeamsOptions() {
      return this.officeTeams?.map(team => {
        return {
          name: team?.attributes?.name,
          id: team?.id
        };
      });
    }
  },
  directives: {
    clear: {
      bind: function(el, binding, vnode) {
        el.onfocus = function() {
          if (parseFloat(el.value) === 0) {
            el.value = null;
          }
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 24px;
  font-weight: 700;
}

.dailyLimit_item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 8px;
}

.dailyLimit_item input {
  width: 140px;
}

.dailyLimit_item label {
  font-size: 14px;
  font-weight: normal;
  color: #000;
  margin-bottom: 6px;
}

.col {
  flex-grow: 0;
}

.modal--container {
  padding: 0 20px;
}

@media (max-width: 768px) {
  .dailyLimit_item input {
    width: 100%;
  }

  .save_btn {
    width: 100%;
  }

  .other_btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OfficeAdmin/EditBulkUsersModal.vue